import fetch from '../req'

//以下为角色管理接口

export function createRoles (query) {
  return fetch({
    url: '/jurisdiction/role/add',
    method: 'post',
    data: query
  })
}

export function getRolesInfo (id) {
  return fetch({
    url: '/jurisdiction/role/' + id,
    method: 'get'
  })
}

export function getRolesList (query) {
  return fetch({
    url: '/jurisdiction/role',
    method: 'get',
    params: query
  })
}

export function updateRolesInfo (id, query) {
  return fetch({
    url: '/jurisdiction/role/update/' + id,
    method: 'post',
    data: query
  })
}

export function deleteRole (id) {
  return fetch({
    url: '/jurisdiction/role/del/' + id,
    method: 'post'
  })
}
